import React, { useState } from 'react'
import './testimonial.css'
import Navigation from '../../Component/Navigation/Navigation'
import Footer from '../../Component/Footer/Footer'
import { toast } from 'wc-toast'

function StarIcon() {
  return (
    <svg className="tm-card__star" viewBox="0 0 20 20" fill="currentColor">
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
  )
}

const testimonials = [
  {
    text: `I was on the verge of giving up on recovering fees from my bank. ${process.env.REACT_APP_APP_NAME}'s team was relentless and knowledgeable — they negotiated a full refund on my behalf in just a few weeks. The funds made a real difference for my family.`,
    name: 'Sarah L.',
    role: 'Freelance Writer',
    stars: 5,
    featured: false,
  },
  {
    text: `My bank's refund policies are notoriously complex. ${process.env.REACT_APP_APP_NAME} cut straight through the red tape and secured a refund on unfair ATM fees within weeks. I'm grateful for their expertise and persistent advocacy.`,
    name: 'Juan D.',
    role: 'Restaurant Owner',
    stars: 5,
    featured: false,
  },
  {
    text: `As a non-profit, every dollar we recover goes straight back into our programs. ${process.env.REACT_APP_APP_NAME} helped us recoup over $1,000 in improper charges — money we reinvested immediately. Their service is a genuine game-changer for organisations like ours.`,
    name: 'Emily G.',
    role: 'Non-Profit Director',
    stars: 5,
    featured: true,
  },
  {
    text: `As a small business owner, cutting costs is always a priority. ${process.env.REACT_APP_APP_NAME} has helped me secure refunds on overdraft fees and other unfair charges multiple times now. I recommend them without hesitation.`,
    name: 'Tom S.',
    role: 'Retail Store Owner',
    stars: 5,
    featured: false,
  },
  {
    text: `${process.env.REACT_APP_APP_NAME} is a lifesaver for busy professionals. I simply don't have the bandwidth to deal with customer service departments, but they handled everything seamlessly. Over $300 recovered in just a few weeks — outstanding.`,
    name: 'Maria P.',
    role: 'Marketing Consultant',
    stars: 5,
    featured: false,
  },
  {
    text: `I'm grateful for ${process.env.REACT_APP_APP_NAME}'s persistence throughout the entire process. They kept me informed at every step, navigated the complexity on my behalf, and delivered a result that genuinely made a difference for my family.`,
    name: 'Anita K.',
    role: 'Homemaker',
    stars: 5,
    featured: false,
  },
  {
    text: `I've used ${process.env.REACT_APP_APP_NAME} several times now and the process keeps getting smoother. They've helped me recover hundreds of dollars in unfair fees, and the level of customer care has been consistently exceptional.`,
    name: 'Jessica R.',
    role: 'Small Business Owner',
    stars: 5,
    featured: false,
  },
  {
    text: `As an entrepreneur, navigating bank policies is the last thing I need on my plate. ${process.env.REACT_APP_APP_NAME} took complete ownership of the process and secured a full refund on unexpected overdraft fees. Highly recommended.`,
    name: 'Michael T.',
    role: 'Startup Founder',
    stars: 5,
    featured: false,
  },
  {
    text: `The mobile app made everything incredibly straightforward. I submitted my details, and within days the team was already in communication with my bank. By the end of the month, my refund was confirmed. Truly effortless.`,
    name: 'Priya M.',
    role: 'Software Engineer',
    stars: 5,
    featured: false,
  },
  {
    text: `I had almost written off $450 in fees as a lost cause. A colleague recommended ${process.env.REACT_APP_APP_NAME} and within three weeks I had a full refund. The team's communication was clear, friendly, and professional throughout.`,
    name: 'David O.',
    role: 'Financial Analyst',
    stars: 5,
    featured: false,
  },
  {
    text: `After years of being overcharged by my bank, ${process.env.REACT_APP_APP_NAME} finally gave me a way to fight back. The results were faster than I ever anticipated, and the team treated my case with real care and dedication.`,
    name: 'Claire B.',
    role: 'Teacher',
    stars: 5,
    featured: false,
  },
  {
    text: `Managing payroll for a small team means every fee matters. ${process.env.REACT_APP_APP_NAME} recovered processing charges I had simply accepted as standard. Their service pays for itself many times over.`,
    name: 'Kofi A.',
    role: 'Agency Director',
    stars: 5,
    featured: true,
  },
]

function initials(name) {
  return name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
}

function Testimonial() {
  const [NLEmail, setNLEmail] = useState(null)

  const handleNLSubmit = (e) => {
    e.preventDefault()
    if (!NLEmail) toast.error('Enter an Email')
    else toast.success('News Letter Signup Successful')
  }

  return (
    <div className="tm-page">
      <Navigation />

      {/* ══════════════════════════════════════════════════════
          PAGE HEADER
      ══════════════════════════════════════════════════════ */}
      <div className="tm-header">
        <div className="tm-header__content">
          <h1 className="tm-header__title">Testimonials</h1>
          <p className="tm-header__breadcrumb">Home &nbsp;/&nbsp; Testimonials</p>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          INTRO BAND
      ══════════════════════════════════════════════════════ */}
      <div className="tm-intro">
        <div className="tm-intro__inner">
          <div className="tm-intro__stat">
            <strong>50k+</strong>
            <span>Happy Clients</span>
          </div>
          <div className="tm-intro__text">
            <span className="tm-intro__eyebrow">What our customers say</span>
            <h2>
              Trusted by clients across every <em>walk of life</em>
            </h2>
            <p>
              At {process.env.REACT_APP_APP_NAME}, we're proud of the relationships we've built with our
              customers. Their success drives everything we do — hear directly from the
              people whose financial lives we've helped transform.
            </p>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          TESTIMONIALS GRID
      ══════════════════════════════════════════════════════ */}
      <div className="tm-section">
        <div className="tm-section__inner">
          <div className="tm-section__head">
            <span className="tm-section__eyebrow">Client Stories</span>
            <h2>
              Real results, <em>real people</em>
            </h2>
          </div>

          <div className="tm-grid">
            {testimonials.map((t, i) => (
              <div
                className={`tm-card${t.featured ? ' tm-card--featured' : ''}`}
                key={i}
              >
                <div className="tm-card__quote">&ldquo;</div>

                <div className="tm-card__stars">
                  {Array.from({ length: t.stars }).map((_, s) => (
                    <StarIcon key={s} />
                  ))}
                </div>

                <p className="tm-card__text">{t.text}</p>

                <div className="tm-card__divider" />

                <div className="tm-card__author">
                  <div className="tm-card__avatar">{initials(t.name)}</div>
                  <div>
                    <div className="tm-card__name">{t.name}</div>
                    <div className="tm-card__role">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          NEWSLETTER
      ══════════════════════════════════════════════════════ */}
      <div className="tm-newsletter">
        <div className="tm-newsletter__inner">
          <div className="tm-newsletter__text">
            <h2>Subscribe to Receive Latest Updates</h2>
            <p>Stay informed with our latest news, offers, and financial insights.</p>
          </div>
          <form className="tm-newsletter__form" onSubmit={handleNLSubmit}>
            <input
              type="email"
              placeholder="Your Email"
              onChange={(e) => setNLEmail(e.target.value)}
            />
            <input type="submit" value="Subscribe" />
          </form>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Testimonial